import React, { useState, useEffect, useRef } from 'react';
import './Header.css';

function Header() {
  const [isNavVisible, setIsNavVisible] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navRef = useRef(); // Ref for the nav element
  const hamburgerRef = useRef(); // Ref for the hamburger icon

  useEffect(() => {
    // Function to handle the event when clicking outside the nav and hamburger
    const handleOutsideClick = (event) => {
      if (navRef.current && !navRef.current.contains(event.target) && 
          hamburgerRef.current && !hamburgerRef.current.contains(event.target)) {
        setIsNavVisible(false);
      }
    };

    // Adding the click event listener to the document
    document.addEventListener('mousedown', handleOutsideClick);

    // Cleanup function to remove the event listener
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  useEffect(() => {
    // Function to handle the resize event
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsNavVisible(false);
      }
    };

    // Function to handle the scroll event
    const handleScroll = () => {
      setScrolled(window.scrollY > 200);
    };

    // Adding the resize and scroll event listeners
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);

    // Cleanup function to remove the event listeners
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Function to handle hover on hamburger icon
  // const handleHover = (event) => {
  //   setIsNavVisible(event.type === 'mouseenter');
  // };

  // Function to generate shooting stars with inline styles for unique positioning
  const createShootingStars = () => {
    let stars = [];
    for (let i = 0; i < 13; i++) { // Generate 7 stars
      // Generate random positions and delays
      const top = Math.random() * 100; // Random position from top of the header
      const left = Math.random() * 70 // Random position from left of the header
      const animationDelay = Math.random() * 5; // Random delay between 0 to 5 seconds

      stars.push(
        <div
          key={i}
          className="shooting_star"
          style={{
            top: `${top}%`,
            left: `${left}%`,
            animationDelay: `${animationDelay}s`
          }}
        ></div>
      );
    }
    return stars;
  };

  return (
    <header id="home" className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="night">
        {createShootingStars()}
      </div>
      <div className={`top-section ${scrolled || isNavVisible ? 'top-scrolled' : ''}`}>
        <div className="logo"> {/* Your logo here */} </div>
        <nav ref={navRef}>
          <div
            ref={hamburgerRef}
            className="hamburger-menu"
            onClick={() => setIsNavVisible(!isNavVisible)}
            // onMouseEnter={handleHover}
            // onMouseLeave={handleHover}
          >
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
          <ul className={`nav-links ${isNavVisible ? 'nav-active' : ''}`}>
            <li><a href="#home" className="keyword">Home</a></li>
            <li><a href="#projects" className="keyword">Projects</a></li>
            <li><a href="#about" className="keyword">About</a></li>
          </ul>
        </nav>
      </div>
      <div className="hero-section">
        <div className="intro-text">
          <h1 className="title">{'>'} Hi, I'm Lara</h1>
          <p className="subtitle">Frontend wizard turning coffee into code and designs into reality.</p>
        </div>
      </div>
    </header>
  );
}


export default Header;



